document.addEventListener("DOMContentLoaded", () => {
    const inputSearchSelector = `input[type='search']`;
    let debounceTimer;
    document.addEventListener("input", (e) => {
        if (e.target && e.target.matches(inputSearchSelector)) {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                window.dispatchEvent(new Event('scroll'));
            }, 300);
        }
    });
}); 

document.addEventListener("click", function (e) {
  const target = e.target.closest(
    ".site-cart-handle.site-menu-handle.overlay"
  );

  if (!target) return;

  window.dispatchEvent(new Event("scroll"));
});


const isPDP = window.location.pathname.includes("/products/");
if (isPDP) {
    let oldHref = location.href;
    new MutationObserver(() => {
        if (oldHref !== location.href) {
            oldHref = location.href;
            const variant = new URL(location.href).searchParams.get('variant');
            setTimeout(() => {
              const productForm = document.querySelector("[bss-b2b-main-product-form]");
              productForm.querySelector("[bss-b2b-variant-id]").setAttribute("bss-b2b-variant-id",variant)
                BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {
                    productForm
                });
                
            }, 600)
        }
    }).observe(document, {
        subtree: true,
        childList: true
    });
} 

let counter = 0;
const interval = setInterval(() => {
  if (window.BSS_B2B) {
    const productItems = document.querySelectorAll("[data-js-product-item]");

    if (productItems.length > 0) {
      productItems.forEach(item => {
        item
          .querySelectorAll(
            "[bss-b2b-product-price], [bss-b2b-product-price] *"
          )
          .forEach(el => {
            el.style.color = "white";
          });
      });
    }

    clearInterval(interval);
  } else {
    counter += 100;
    if (counter >= 10000) {
      clearInterval(interval);
    }
  }
}, 100);
